import React from 'react';
import { motion } from 'framer-motion';

const CENTER_IMG = "assets/img/WhatsApp-Image-2026-03-23-at-4.16.12-PM-8.jpeg";

export default function About() {
  return (
    <section id="about" className="py-24 sm:py-32 bg-muted/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Text */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >
            <p className="text-primary font-medium tracking-[0.2em] uppercase text-sm mb-4">About ROJCD</p>
            <h2 className="text-3xl sm:text-4xl font-heading font-bold text-foreground mb-6">
              Your Place for{' '}
              <span className="text-primary italic">Transformation</span>{' '}
              &amp; <span className="text-secondary italic">Restoration</span>
            </h2>
            <div className="space-y-4 text-muted-foreground leading-relaxed">
              <p>
                Rose of Jericho Community Development Center is a beacon of hope rooted in two communities separated by miles but united by purpose: Riverside County, California, and Accra, Ghana.
              </p>
              <p>
                As a recognized 501(c)(3) organization, we believe that sustainable change begins at the community level. Our integrated approach brings together economic development, education, healthcare access, and social services — not as isolated programs, but as interconnected pathways to generational transformation.
              </p>
              <p>
                <strong className="text-foreground">We are more than a center. We are a community in motion.</strong>
              </p>
              <p>
                Our impact speaks for itself: community feedings that have served over 1,000 women and children, medical missions reaching more than 400 adults, and a growing network of partners and volunteers committed to proving that real change starts from the ground up. Every meal served, every patient seen, every skill taught is a step toward the thriving, self-sustaining communities we are building together.
              </p>
            </div>
          </motion.div>

          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img src={CENTER_IMG} alt="Rose of Jericho Community Center" className="w-full h-auto" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}